import axios from "../../../axiosClient";

export const getFloorDetails = async (
  blockCode: any,
  floorCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/BlockToFloor/getFloorByBlockCode`, {
    params: { floorCode, blockCode },
    signal,
  });

  return res?.data;
};

export const getFloorAssetsAndShapes = async (
  blockCode: any,
  floorCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/BlockToFloor/getFloorPlans`, {
    params: { blockCode, floorCode },
    signal,
  });

  return res?.data;
};

export const getFloorPlansByGateway = async (
  blockCode: any,
  floorCode: any,
  gatewayCode: string,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/BlockToFloor/getFloorPlansByGateway`, {
    params: { blockCode, floorCode, gatewayCode },
    signal,
  });

  return res?.data;
};

export const getFloorsWithSimilarPlan = async (
  blockCode: any,
  floorCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/BlockToFloor/getFloorsWithSimilarPlan`, {
    params: { blockCode, floorCode },
    signal,
  });

  return res?.data;
};

export const getAssetWiseLastHourMotion = async (
  blockCode: any,
  floorCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/Block/AssetWiseLastHourMotion`, {
    params: { blockCode, floorCode },
    signal,
  });

  return res?.data?.data;
};

/* export const getFloorPlanOfflineCount = async (blockCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/BlockToFloor/getFloorPlanOfflineCount`, {
    params: { blockCode },
    signal,
  });

  return res?.data?.data;
}; */
